<div class="container-fluid preview-container p-0 m-0">
  @if (currentView) {
  <div class="row justify-content-between p-0 m-0 align-items-center" [class.title-row--stacked]="isSegSolicitudes">

    <div class="col-auto p-0">
      @if (currentView !== 'preview1') {
      <app-title [titleText]="getTitleWithConfig()" [backFunction]="true" [currentView]="currentView"
        (returnDetails)="onReturn()"></app-title>
      } @else {
      <app-title [titleRouter]="getTitleWithConfig()" [backFuction]="true" [currentView]="currentView"
        (returnDetails)="onReturn()"></app-title>
      }
    </div>
    <div class="col-auto p-0 m-0">
      <div class="d-flex align-items-center">

        <!-- Botón para cambiar configuración (solo en preview1 y si hay múltiples configs) -->
        @if (currentView === 'preview1' && hasMultipleConfigs) {
        <button type="button" class="efx-button-secondary me-3" (click)="onChangeConfig.emit()"
          title="Cambiar configuración">
          <span class="material-symbols-outlined me-1">settings</span>
          Cambiar configuración
        </button>
        }

        @if (currentView === 'detail') {
        @if (showMovimientosButton && !showRds && !isPurpusing) {
        <div class="me-3">
          <button type="button" class="efx-button-secondary log-viewer-button" (click)="openLogModal()"><span
              class="material-symbols-outlined me-1">description</span>Movimientos
          </button>
        </div>
        }
        @if (showHistoryHtml && !esInternoRdsVista) {
        <app-historial-fuentes-panel (onSlideToggle)="onToggleHistorial.emit($event)"
          (onHistorySelected)="onTimestampSelected.emit($event)" [toggleValue]="toggleValue"
          [disabledHistorial]="disabledHistorialHtml" [dataHistorial]="historyList" [btnVisible]="!isPurpusing"
          [dataHistorialModal]="historyListModal"></app-historial-fuentes-panel>
        }
        @if (isEditing) {
        <button type="button" class="efx-button-secondary me-3" (click)="onCancelButton.emit()"
          title="Cancelar">CANCELAR
        </button>
        }
        @if (isEditing) {
        <button type="button" class="efx-button-primary" [disabled]="disabledSaveButton" (click)="onSaveButton.emit()"
          title="Guardar">GUARDAR
        </button>
        }
        @if (conditionEditar()) {
        <button type="button" class="efx-button-primary me-3" (click)="onEditButton.emit()" title="Editar"><span
            class="material-symbols-outlined">edit</span>EDITAR
        </button>
        }
        }
        @if (currentView === 'preview1' || currentView === 'preview2') {
        @if (currentView === 'preview2' && showLatestFilterSwitch) {
        <div class="me-3 pt-4">
          <div class="form-check form-switch custom-switch-container">
            <input class="form-check-input" type="checkbox" role="switch" id="showLatestSwitch"
              [checked]="showOnlyLatest" (change)="onShowLatestChange.emit($event.target.checked)">
            <label class="form-check-label ms-2" for="showLatestSwitch">Mostrar solo el último mes
              actualizado</label>
          </div>
        </div>
        }
        <!--            <button *ngIf="currentView === 'preview2' && isAnyRowSelected" type="button" class="efx-button-primary me-3"-->
        <!--                    (click)="onEdicionMasiva.emit()" title="Editar masivamente los registros seleccionados"><span-->
        <!--              class="material-symbols-outlined" style="vertical-align: middle;">edit_square</span>EDICIÓN MASIVA-->
        <!--            </button>-->
        @if ((currentView === 'preview1' || currentView === 'preview2') && showSoftDelete) {
        <div class="me-3">
          <div class="form-check form-switch custom-switch-softdelete"> <input class="form-check-input" type="checkbox"
              role="switch" id="softDeleteToggle" [checked]="viewSoftDeleted"
              (change)="onViewSoftDeleted.emit($event.target.checked)">
            <label class="form-check-label" for="softDeleteToggle">Soft delete</label>
          </div>
        </div>
        }
        @if (!esInternoRdsVista) {
        <div>
          @if (isSegSolicitudes) {
          <button class="efx-button-secondary me-2" (click)="findAllDetailPaged.emit($event.checked)">
            Actualizar Todo <span class="material-symbols-outlined cursor-pointer">sync</span>
          </button>
          }
          <button class="efx-button-secondary" (click)="togglePanelFilter()"><span
              class="material-symbols-outlined me-1">filter_alt</span>Filtrar
          </button>
        </div>
        }
        }
      </div>
    </div>
  </div>
  @if ((currentView === 'preview1' || currentView === 'preview2') && panelFilter) {
  <div class="inline-panel-container">
    <div class="row filter-content w-100 p-3">
      <app-filter></app-filter>
    </div>
  </div>
  }
  @if (currentView === 'preview1' || currentView === 'preview2') {
  <div class="d-flex justify-content-between align-items-center mt-3">
    <div>
      @if (showRds) {

      <div class="rds-search-row">
        <label class="efx-label mb-0">Buscar por:</label>

        <select class="efx-select select-options-rds" [(ngModel)]="selectedKeyTypeRDS">
          <option *ngFor="let selectOptions of selectOptionsRDS" [value]="selectOptions">
            {{ selectOptions | titlecase }}
          </option>
        </select>

        <div class="input-group">
          <input type="text" list="id-datalist-rds" id="id-datalist-choice-rds" name="id-datalist-choice-rds"
            class="form-control ancho-doble" [(ngModel)]="dataPrimarykeyRds"
            [placeholder]="selectedKeyTypeRDS" (keyup.enter)="clickBusquedaRds()">
          <button class="efx-button-primary" type="button" (click)="clickBusquedaRds()">
            <span class="material-symbols-outlined">search</span>
          </button>
          <datalist id="id-datalist-rds" class="efx-datalist-custom">
            @for (acuList of rdsPrimarykeys; track acuList) {
            <option [value]="acuList.code">{{ acuList.code + ': ' +
              acuList.description }}
            </option>
            }
          </datalist>
        </div>

        <button class="efx-button-primary btn-get-rds" (click)="getRdsDataByCollection()">
          <span>Obtener Todos los Datos</span>
        </button>
      </div>
      }
    </div>
    <div class="d-flex">
      @if (showDeleteButtonLogic) {
      <div class="me-3">
        <button class="efx-button-delete animate__animated animate__zoomIn" (click)="onDeleteButton.emit()"><span
            class="material-symbols-outlined">delete</span>Eliminar
        </button>
      </div>
      }
      @if (showBulkEditButtonLogic) {
      <div class="me-3">
        <button class="efx-button-secondary animate__animated animate__zoomIn" (click)="onEdicionMasiva.emit()">
          Edición masiva
        </button>
      </div>
      }
       @if (hasHeaderFunctions && isAnyRowSelected) {
        <div class="me-3">
          <div class="dropdown">
            <button type="button" class="efx-button-secondary dropdown-toggle" data-bs-toggle="dropdown"
              aria-expanded="false" title="Funciones disponibles">
              Funciones
            </button>
            <ul class="dropdown-menu">
              @for (headerFunction of headerFunctionsForCurrentView; track headerFunction?.name + '-' + $index) {
              <li>
                <a class="dropdown-item cursor-pointer" (click)="onHeaderFunctionChange(headerFunction)">
                  <div [ngClass]="{'border-bottom': !$last}" class="d-block align-items-center gap-2 border-bottom p-3">
                    <strong>{{ headerFunction.name }}</strong>

                     <div class="description">
                      <span>{{ headerFunction.description }}</span>
                     </div>

                  </div>

                </a>
              </li>
              }
            </ul>
          </div>
        </div>
        }
      @if (showAddButtonLogic) {
      <div>
        <button class="efx-button-primary" (click)="onAddButton.emit()"><span
            class="material-symbols-outlined">add</span>Agregar
        </button>
      </div>
      }
      @if (condicionMotivoEliminacionSicomMicro()) {
      <div class="me-3">
        <div class="dropdown">
          <button type="button" class="efx-button-delete animate__animated animate__zoomIn" data-bs-toggle="dropdown"
            aria-expanded="false">
            <span class="material-symbols-outlined me-1">description</span>Motivo de eliminación
          </button>
          <ul class="dropdown-menu">
            <li>
              <a class="dropdown-item" (click)="onSaveEliminacionSuplantacionIdentidad.emit()">Suplantación de
                identidad</a>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li class="dropdown dropstart">
              <a class="dropdown-item dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">Cancelación o
                Pago</a>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" (click)="onSaveEliminacionCancelacionPagoCarteraVencidaAlDia.emit()">Cartera
                    Vencida y al día</a>
                </li>
                <li>
                  <hr class="dropdown-divider">
                </li>
                <li>
                  <a class="dropdown-item" (click)="onSaveEliminacionCancelacionPagoCarteraSoloVencida.emit()">Cartera
                    Sólo vencida</a>
                </li>
              </ul>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li class="dropdown dropstart">
              <a class="dropdown-item dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">Solicitado por
                Proveedor</a>
              <ul class="dropdown-menu">
                <li class="dropdown dropstart">
                  <a class="dropdown-item dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">Periodo
                    Eliminación Actual</a>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item"
                        (click)="onSaveEliminacionProveedorPeriodoActualCarteraVencidaAlDia.emit()">Cartera Vencida y al
                        día</a>
                    </li>
                    <li>
                      <hr class="dropdown-divider">
                    </li>
                    <li>
                      <a class="dropdown-item"
                        (click)="onSaveEliminacionProveedorPeriodoActualCarteraSoloVencida.emit()">Cartera Sólo
                        vencida</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <hr class="dropdown-divider">
                </li>
                <li class="dropdown dropstart">
                  <a class="dropdown-item dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">Periodo
                    Eliminación Histórico</a>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item"
                        (click)="onSaveEliminacionProveedorPeriodoHistoricoCarteraVencidaAlDia.emit()">Cartera Vencida y
                        al día</a>
                    </li>
                    <li>
                      <hr class="dropdown-divider">
                    </li>
                    <li>
                      <a class="dropdown-item"
                        (click)="onSaveEliminacionProveedorPeriodoHistoricoCarteraSoloVencida.emit()">Cartera Sólo
                        vencida</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <hr class="dropdown-divider">
                </li>
                <li class="dropdown dropstart">
                  <a class="dropdown-item dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">Periodo
                    Eliminación Fecha Desde</a>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item"
                        (click)="onSaveEliminacionProveedorPeriodoFechaDesdeCarteraVencidaAlDia.emit()">Cartera Vencida
                        y
                        al día</a>
                    </li>
                    <li>
                      <hr class="dropdown-divider">
                    </li>
                    <li>
                      <a class="dropdown-item"
                        (click)="onSaveEliminacionProveedorPeriodoFechaDesdeCarteraSoloVencida.emit()">Cartera Sólo
                        vencida</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      }
    </div>
  </div>
  }
  } @else {
  <div class="row justify-content-between p-0 m-0">
    @if (!detailSelected) {
    <div class="col-4 p-0">
      <app-title [titleRouter]="nombreFuente" [backFuction]="true" (returnDetails)="onReturn()"></app-title>
    </div>
    }
    <div class="col-8 p-0 m-0">
      @if (!detailSelected) {
      <div class="col-xs-1 col-md px-0 efx-edit-div-button">
        @if (showMovimientosButton && !showRds) {
        <div class="me-3">
          <button type="button" class="efx-button-secondary log-viewer-button" (click)="openLogModal()"><span
              class="material-symbols-outlined me-1">description</span>Movimientos
          </button>
        </div>
        }
        @if (showHistoryHtml && !esInternoRdsVista) {
        <app-historial-fuentes-panel (onSlideToggle)="onToggleHistorial.emit($event)"
          (onHistorySelected)="onTimestampSelected.emit($event)" [toggleValue]="toggleValue"
          [disabledHistorial]="disabledHistorialHtml" [dataHistorial]="historyList" [btnVisible]="!isPurpusing"
          [dataHistorialModal]="historyListModal"></app-historial-fuentes-panel>
        }
        @if ((isCreating? isEditing || isCreating : isEditing)) {
        <button type="button" class="efx-button-secondary me-3" (click)="onCancelButton.emit()"
          title="Cancelar">CANCELAR
        </button>
        }
        @if (isCreating? isEditing || isCreating : isEditing) {
        <button type="button" class="efx-button-primary" [disabled]="disabledSaveButton" (click)="onSaveButton.emit()"
          title="Guardar">GUARDAR
        </button>
        }
        @if (isEditing==false && isCreating==false && isCreating!=undefined) {
        <button [disabled]="disableAdd" type="button" class="efx-button-secondary me-3" (click)="onAddButton.emit(true)"
          title="Agregar">
          AGREGAR
        </button>
        }
        @if ((periods && isEditing===false)) {
        <button [disabled]="!disabledAddButton" type="button" class="efx-button-secondary ms-3 me-3"
          (click)="onAddButton.emit(true)" title="Agregar">AGREGAR
        </button>
        }
        @if (conditionEditar2()) {
        <button type="button" class="efx-button-primary  me-3" (click)="onEditButton.emit()" title="Editar"><span
            class="material-symbols-outlined"> edit </span>EDITAR
        </button>
        }
      </div>
      }
    </div>
  </div>
  @if (detailSelected) {
  <div class="container-filter d-flex justify-content-between">
    <div>
      <app-title [titleRouter]="nombreFuente"></app-title>
    </div>
    <div class="d-flex align-items-center mb-24px">
      <div class="me-3 pt-4">
        @if (showSoftDelete) {
        <efx-slide-toggle id="slide-toggle-basic" ariaLabelledBy="toggle-label" labelPosition="after"
          [checked]="viewSoftDeleted" (onChange)="onViewSoftDeleted.emit($event.checked)"> Soft delete
        </efx-slide-toggle>
        }
      </div>

      @if (!esInternoRdsVista) {
      <div>
        <button class="efx-button-secondary" (click)="togglePanelFilter()"><span
            class="material-symbols-outlined me-1">filter_alt</span>Filtrar
        </button>
      </div>
      }
    </div>
  </div>
  @if (panelFilter) {
  <div class="inline-panel-container">
    <div class="row filter-content w-100 p-3">
      <app-filter></app-filter>
    </div>
  </div>
  }
  <div class="d-flex justify-content-between">
    <div>
      @if (showRds) {
      <label class="efx-label">Primarykey
        <div class="tooltip2"><span class="material-symbols-outlined"> info </span><span
            class="tooltip3 tooltiptext2">{{
            variableLocalPrimaryKeyFieldRdsVista }}</span></div>
      </label>
      <div class="d-flex align-items-start">
        <div class="me-3">
          <div class="input-group mb-3">@if (showRds) {
            <input type="text" list="id-datalist-rds" id="id-datalist-choice-rds" name="id-datalist-choice-rds"
              class="form-control ancho-doble" [(ngModel)]="dataPrimarykeyRds" placeholder=""
              aria-label="Recipient's username" aria-describedby="button-addon-rds"
              [placeholder]="variableLocalPrimaryKeyFieldRdsVista" (keyup.enter)="clickBusquedaRds()">
            }
            <button class="right-button btn-derecha" type="button" id="button-addon-rds"
              (click)="clickBusquedaRds()"><span class="material-symbols-outlined">search</span></button>
          </div>
          @if (showRds) {
          <datalist id="id-datalist-rds" class="efx-datalist-custom">
            @for (acuList of rdsPrimarykeys; track acuList) {
            <option [value]="acuList.code">{{ acuList.code + ': ' + acuList.description }}
            </option>
            }
          </datalist>
          }
        </div>
        <div class="ml-40">
          <button class="efx-button-primary" (click)="getRdsDataByCollection()">
            <span>Obtener Todos los Datos</span></button>
        </div>
      </div>
      }
    </div>
    <div class="d-flex">
      @if (disableDeleteButton) {
      <div class="me-3">
        <button class="efx-button-delete animate__animated animate__zoomIn" (click)="onDeleteButton.emit()">
          <span class="material-symbols-outlined">delete</span>Eliminar
        </button>
      </div>
      }
      @if (conditionEdicionMasiva()) {
      <div class="me-3">
        <button class="efx-button-secondary animate__animated animate__zoomIn" (click)="onEdicionMasiva.emit()">
          Edición masiva
        </button>
      </div>
      }
      @if (buttonAdd || showAddObs) {
      <div>
        <button class="efx-button-primary" (click)="showAddObs ? onNewObservation.emit():onAddButton.emit()"><span
            class="material-symbols-outlined">add</span>Agregar
        </button>
      </div>
      }
    </div>
  </div>
  }
  }

</div>
